/* Replace full file in C:\TravelAdvisorApp\client\src\components\EditClientModal.js */
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DetailComponents.css';

const EditClientModal = ({ client, onSave, onClose }) => {
  const [editedClient, setEditedClient] = useState({
    ...client,
    dob: client.dob ? new Date(client.dob) : null
  });

  const handleSave = () => {
    const formattedClient = {
      ...editedClient,
      dob: editedClient.dob ? editedClient.dob.toISOString().split('T')[0] : ''
    };
    onSave(formattedClient);
  };

  return (
/* Replace return statement in C:\TravelAdvisorApp\client\src\components\EditClientModal.js */
<div className="modal-overlay">
  <div className="modal edit-modal">
    <h3>Edit Client</h3>
    <div className="edit-modal-form">
      <div className="edit-modal-field">
        <label className="edit-modal-label">First Name:</label>
        <input className="edit-modal-input" value={editedClient.name} onChange={e => setEditedClient({ ...editedClient, name: e.target.value })} />
      </div>
      <div className="edit-modal-field">
        <label className="edit-modal-label">Middle Name:</label>
        <input className="edit-modal-input" value={editedClient.midName || ''} onChange={e => setEditedClient({ ...editedClient, midName: e.target.value })} />
      </div>
      <div className="edit-modal-field">
        <label className="edit-modal-label">Last Name 1:</label>
        <input className="edit-modal-input" value={editedClient.lastName1} onChange={e => setEditedClient({ ...editedClient, lastName1: e.target.value })} />
      </div>
      <div className="edit-modal-field">
        <label className="edit-modal-label">Last Name 2:</label>
        <input className="edit-modal-input" value={editedClient.lastName2 || ''} onChange={e => setEditedClient({ ...editedClient, lastName2: e.target.value })} />
      </div>
      <div className="edit-modal-field">
        <label className="edit-modal-label">Date of Birth:</label>
        <DatePicker
          selected={editedClient.dob}
          onChange={date => setEditedClient({ ...editedClient, dob: date })}
          dateFormat="MMMM d, yyyy"
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          className="edit-modal-input"
        />
      </div>
      <div className="edit-modal-field">
        <label className="edit-modal-label">Email:</label>
        <input className="edit-modal-input" value={editedClient.email} onChange={e => setEditedClient({ ...editedClient, email: e.target.value })} />
      </div>
    </div>
    <div className="modal-actions">
      <button className="modal-action-button" onClick={onClose}>Cancel</button>
      <button className="modal-action-button" onClick={handleSave}>Save</button>
    </div>
  </div>
</div>
  );
};

export default EditClientModal;